export default {
  shinkansen: {
    title: '신칸센 온라인 예약 | Triplabo',
    caption: '일본 신칸센 공식 지정 플랫폼',
    description:
      'JR 공식 인증 파트너. 주요 신칸센 노선을 미리 예약하고 QR 코드로 빠르고 편하게 탑승하세요.',
    departure: '출발',
    arrival: '도착',
    departureDate: '출발일',
    ticketType: '신칸센 티켓',
    earliestTime: '최초 출발 시간',
    latestTime: '최후 출발 시간',
    travelTime: '승차 시간',
    attractions: '인기 관광지',
    stock: {
      sufficient: '예약가능',
      limited: '잔여 좌석 부족',
      soldOut: '매진'
    },
    book: {
      reserve: '예약',
      selectSeat: '좌석 선택'
    },
    preference: {
      earliestDeparture: '최초 출발',
      fastestArrival: '최단 도착',
      lowestPrice: '최저 가격'
    },
    popularRoutes: {
      title: '인기 노선',
      jr: {
        name: '일본JR 공식 협력 플랫폼',
        description: '신뢰할 수 있는 일본 철도 공식 예약 시스템'
      },
      qr: {
        name: '초속 티켓, QR 코드로 승차',
        description: '게이트 전에도 안심! QR 코드로 바로 승차 가능'
      },
      reserve: {
        name: '1일 전 예약, 취소도 쉬움',
        description:
          '일정이 바뀌어도, 게이트 전에 취소 & 재예약 가능!*\n（*자유석은 당일 내에 이용 가능）'
      }
    },
    usageInstructions: {
      title: '이용 방법',
      step1: {
        title: '온라인으로 티켓 예약 후 QR코드 승차권 받기',
        description:
          '*JR 규정에 따라 신칸센 티켓은 현재 출발 1개월 전부터만 발권 가능합니다.'
      },
      step2: {
        title: '신칸센 개찰구에서 QR코드 스캔 후 입장',
        description:
          '*오류 메시지가 표시되면 개찰구 역무원에게 QR코드 승차권을 보여주세요.'
      },
      step3: {
        title: '플랫폼과 열차 찾기',
        description:
          '*자유석 승객은 자유석 전용으로 지정된 열차를 이용해야 하며 좌석은 선착순입니다.'
      }
    },
    duration: {
      hoursAndMinutes: '{{hours}}시간 {{minutes}}분',
      minutes: '{{minutes}}분',
      approximately: '약 {{duration}}'
    },
    tags: {
      shinkansen: '신칸센',
      qrcode: 'QR 코드'
    },
    faq: {
      q1: '신칸센 티켓을 어떻게 사용하나요?',
      a1: '신칸센 티켓은 QR 코드로 직접 승차할 수 있는 전자 티켓입니다. 결제 후, 시스템은 신칸센 공식 플랫폼에서 실시간으로 티켓을 예약하고, QR 코드 승차권은 미니 프로그램의 주문 티켓에 표시되며, 등록 시 제공한 이메일 주소로 전송됩니다. 출발 전에 받은 QR 코드 티켓 정보를 확인하세요. 여러 장의 티켓을 구매하는 경우, 여러 개의 QR 코드 티켓이 전송됩니다. 1인 1개의 QR 코드, QR 코드는 1회만 스캔할 수 있습니다. 주의하세요.',
      q2: '열차에 타지 못한 경우 어떻게 해야 하나요?',
      a2: '신칸센에 타지 못한 경우, 동일 날짜의 다른 열차의 자유석에 직접 승차할 수 있습니다. 자리를 보장하고 싶다면, 역에서 새로운 지정석 티켓을 구매할 수 있지만, 이전 티켓은 취소 또는 환불할 수 없습니다.',
      q3: '얼마나 많은 짐을 가져갈 수 있나요?',
      a3: '총 250cm 이내의 짐을 가져갈 수 있습니다. 그 외의 경우 열차에 가져갈 수 없습니다. 열차 내 짐 보관 공간: 각 열차에는 중형 짐을 보관할 수 있는 짐 보관 공간이 있습니다. 자리 앞 공간: 자리 앞 공간을 사용하여 소형 짐을 놓을 수 있습니다. (다리 공간을 좁힙니다) 열차 끝 짐 보관 공간: 일부 열차에는 열차 끝 (마지막 열차 또는 화장실 근처)에 대형 짐을 보관할 수 있는 더 큰 짐 보관 공간이 있습니다. 그러나 공간은 제한되어 있으며, 선착순입니다. *통로 또는 자리 사이 통로에 짐을 놓을 수 없습니다. 다른 승객이 통과하는 것을 방해할 수 있습니다.'
    }
  }
};
